<mat-card>
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; padding: 16px;">
        <h4>Total by Model</h4>
        <div style="display: flex; align-items: center; width:52px; height: 52px;">
            <mat-progress-spinner *ngIf="isLoadingMakes" mode="indeterminate" style="margin-right: 10px;"></mat-progress-spinner>
        </div>
    </div>
    <div style="display: flex; justify-content: space-between; width: 100%;">
    
<mat-form-field class="make-select" style="flex: 1; margin-right: 8px;">
  <mat-label>Make</mat-label>
  <mat-select [(ngModel)]="selectedMake" (selectionChange)="onMakeChange()">
    <mat-option>
      <ngx-mat-select-search
        [formControl]="makeFilterCtrl"
        placeholderLabel="Search Make..."
        noEntriesFoundLabel="No matching Make found">
      </ngx-mat-select-search>
    </mat-option>
    <mat-option *ngFor="let make of filteredMakes" [value]="make">
      {{ make }}
    </mat-option>
  </mat-select>
</mat-form-field>

    <mat-form-field class="manual-type-select" style="flex: 1;">
  <mat-label>Manual Type</mat-label>
  <mat-select [(ngModel)]="selectedManualType" (selectionChange)="onManualTypeSelected($event.value)">
    <mat-option>
      <ngx-mat-select-search
        [formControl]="manualTypeFilterCtrl"
        placeholderLabel="Search Manual Type..."
        noEntriesFoundLabel="No matching Manual Type found">
      </ngx-mat-select-search>
    </mat-option>
    <mat-option *ngFor="let type of filteredManualTypes" [value]="type">
      {{ type }}
    </mat-option>
  </mat-select>
</mat-form-field>

</div>
    <table mat-table [dataSource]="dataSource" matSort #mainSort="matSort" class="full-width-table" multiTemplateDataRows>
        <!-- Column definitions -->
        <ng-container matColumnDef="make">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="make" class="header-cell"> Make </th>
            <td mat-cell *matCellDef="let element"> {{ element.make }} </td>
        </ng-container>

        <ng-container matColumnDef="PDFLinkedFlags">
            <th mat-header-cell *matHeaderCellDef class="header-cell"> PDF Linked Flags </th>
            <td mat-cell *matCellDef="let element" >
                <div (click)="handleFlags('linked', element.make)" style="cursor: pointer; color: #0A14F5;">
                    {{element.PDFLinkedFlags.linked.value}}
                </div>
                 <div (click)="handleFlags('noModel', element.make)" style="cursor: pointer; color: #0A14F5;">
                    {{element.PDFLinkedFlags.noModel.value}}
                </div>
                <div (click)="handleFlags('noSN', element.make)" style="cursor: pointer; color: #0A14F5;">
                    {{element.PDFLinkedFlags.noSN.value}}
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="equipmentCost">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell"> Equipment Cost </th>
            <td mat-cell *matCellDef="let element">
                <div>{{element.equipmentCost.linked.value}}</div>
                <div>{{element.equipmentCost.noModel.value}}</div>
                <div>{{element.equipmentCost.noSN.value}}</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="percentageOfTotalOEC">
            <th mat-header-cell *matHeaderCellDef  mat-sort-header class="header-cell"> % of Total OEC </th>
            <td mat-cell *matCellDef="let element">
                <div>{{element.percentageOfTotalOEC.linked.value}}</div>
                <div>{{element.percentageOfTotalOEC.noModel.value}}</div>
                <div>{{element.percentageOfTotalOEC.noSN.value}}</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="distinctEquipmentCodeCount">
            <th mat-header-cell *matHeaderCellDef  mat-sort-header class="header-cell"> Distinct Equipment Code Count </th>
            <td mat-cell *matCellDef="let element">
                <div>{{element.distinctEquipmentCodeCount.linked.value}}</div>
                <div>{{element.distinctEquipmentCodeCount.noModel.value}}</div>
                <div>{{element.distinctEquipmentCodeCount.noSN.value}}</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="percentageOfTotalCount">
            <th mat-header-cell *matHeaderCellDef  mat-sort-header class="header-cell"> % of Total Count </th>
            <td mat-cell *matCellDef="let element">
                <div>{{element.percentageOfTotalCount.linked.value}}</div>
                <div>{{element.percentageOfTotalCount.noModel.value}}</div>
                <div>{{element.percentageOfTotalCount.noSN.value}}</div>
            </td>
        </ng-container>

        <!-- Header and Row Declarations -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</mat-card>

<div style="display: flex; justify-content: space-between; margin-top: 15px;">
    <mat-card style="flex: 1; margin-right: 8px;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; padding: 16px;">
            <h4>Model</h4>
            <div style="display: flex; flex-direction: column; align-items: end;">
                <span>{{selectedMake}}</span>
                <small style="font-weight: bold;">
                   {{ selectedFlag === 'linked' ? 'Models with PDF Linked' : selectedFlag === 'noModel' ? 'Models without PDF Linked' : selectedFlag === 'noSN' ? 'Models without SN Linked' : '' }}
                </small>
            </div>
        </div>
        <mat-progress-spinner *ngIf="isLoadingTotalByModel" mode="indeterminate"></mat-progress-spinner>
        <div style="overflow-y: auto; max-height: 400px;">
        <table mat-table [dataSource]="totalByModelDataSourceDS" matSort #modelSort="matSort">
                <!-- Make Column -->
                <ng-container matColumnDef="make">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell"> Make </th>
                    <td mat-cell *matCellDef="let model">{{ model.make }}</td>
                </ng-container>

                <!-- Model Column -->
                <ng-container matColumnDef="model">
                    <th mat-header-cell *matHeaderCellDef  mat-sort-header class="header-cell"> Model </th>
                    <td mat-cell *matCellDef="let model">
                        <div (click)="handleModel(selectedMake, model.model, model.model_gen, model.model_manual)" style="cursor: pointer; color: #0A14F5;">
                            {{ model.model }}
                        </div>
                    </td>
                </ng-container>
            
                <!-- Distinct Equipment Code Count Column -->
                <ng-container matColumnDef="distinctEquipmentCodeCount">
                    <th mat-header-cell *matHeaderCellDef  mat-sort-header class="header-cell"> Distinct Equipment Code Count </th>
                    <td mat-cell *matCellDef="let model">{{ model.distinctEquipmentCodeCount }}</td>
                </ng-container>

                <!-- Equipment Cost Column -->
                <ng-container matColumnDef="equipmentCost">
                    <th mat-header-cell *matHeaderCellDef  mat-sort-header class="header-cell"> Equipment Cost </th>
                    <td mat-cell *matCellDef="let model">{{ model.equipmentCost | currency:'USD' }}</td>
                </ng-container>

                <!-- Header and Row Declarations -->
                <tr mat-header-row *matHeaderRowDef="totalByModelDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: totalByModelDisplayedColumns;"></tr>    
            </table>
              </div>
                <!-- PAGINATOR -->
        <mat-paginator 
            #modelPaginator
            [pageSizeOptions]="[5, 10, 20]"
            showFirstLastButtons>
        </mat-paginator>
    </mat-card>

    <mat-card style="flex: 1; margin-left: 8px;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; padding: 16px;">
            <h4>Details</h4>
            <div *ngIf="selectedModelDisplay">
                <input type="file" id="fileInput" style="display: none; min-width: 230px;" disabled="true">
                <label for="fileInput"
                       mat-button
                       class="upload-button"
                       (click)="openUploadModal()">
                  <mat-icon>file_upload</mat-icon>
                  Upload Files
                </label>
                <small>
                  {{ selectedModelDisplay  ? 'Upload files for ' + selectedModelDisplay  + ' - ' + selectedMake : '' }}
                </small>
              </div>
        </div>
        <mat-progress-spinner *ngIf="isLoadingDetailedModel" mode="indeterminate"></mat-progress-spinner> 
        <div style="overflow-y: auto; max-height: 400px;">
        <table mat-table [dataSource]="detailedModelDataSource" matSort #detailSort="matSort">
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef  class="header-cell">ID</th>
                <td mat-cell *matCellDef="let item">{{ item.id }}</td>
            </ng-container>

            <ng-container matColumnDef="equipmentCode">
                <th mat-header-cell *matHeaderCellDef  class="header-cell">Equipment Code</th>
                <td mat-cell *matCellDef="let item">{{ item.equipmentCode }}</td>
            </ng-container>

            <ng-container matColumnDef="serialNumber">
                <th mat-header-cell *matHeaderCellDef  class="header-cell">Serial Number</th>
                <td mat-cell *matCellDef="let item">{{ item.serialNumber }}</td>
            </ng-container>

            <ng-container matColumnDef="make">
                <th mat-header-cell *matHeaderCellDef  class="header-cell">Make</th>
                <td mat-cell *matCellDef="let item">{{ item.make }}</td>
            </ng-container>

            <ng-container matColumnDef="model">
                <th mat-header-cell *matHeaderCellDef  class="header-cell">Model</th>
                <td mat-cell *matCellDef="let item">{{ item.model}}</td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef  class="header-cell">Status</th>
                <td mat-cell *matCellDef="let item">
                {{ item.status === 'linked' ? 'Linked' : item.status === 'noModel' ? 'Manual not available for Model' : 'Manual not available for Serial' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="cost">
                <th mat-header-cell *matHeaderCellDef  class="header-cell">Cost</th>
                <td mat-cell *matCellDef="let item">{{ item.cost | currency:'USD' }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="['id', 'equipmentCode', 'serialNumber', 'make', 'model', 'status', 'cost']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['id', 'equipmentCode', 'serialNumber', 'make', 'model', 'status', 'cost'];"></tr>
            </table>
            <div *ngIf="!isLoadingDetailedModel && selectedModel && detailedModelDataSource?.data?.length === 0" style="padding: 16px; color: #757575;">
                   <ng-container *ngIf="!selectedMake || selectedMake.trim() === ''">
                    <p> Invalid make. No manuals found for this make.</p>
                </ng-container>
                <ng-container *ngIf="selectedMake && selectedMake.trim() !== ''">
                    <p> Item without manuals. If you want to add a manual, click the upload button above.</p>
                </ng-container>
            </div>
      
        </div>
           <!--  PAGINATOR -->
        <mat-paginator 
            #detailPaginator
            [pageSizeOptions]="[5, 10, 20]"
            showFirstLastButtons>
        </mat-paginator>
    </mat-card>
</div>